import { render, staticRenderFns } from "./Novice.vue?vue&type=template&id=28b7ade7"
import script from "@/js/novice.ts?vue&type=script&lang=ts&external"
export * from "@/js/novice.ts?vue&type=script&lang=ts&external"
import style0 from "./Novice.vue?vue&type=style&index=0&id=28b7ade7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports